//region 2. Project Libraries
import { logger } from '../DataAPI';
//endregion

export default function checkPort(req, res, next) {
    const log = (lvl, msg) => logger.log(lvl, msg, { tags: 'checkPort' });
    if (typeof req.body.port === 'undefined') {
        const message = 'No Port';
        log('error', message);
        res.status(400).send(message);
        return;
    }
    // if (typeof req.body.port !== 'number') {
    //     const message = 'Malformed Port';
    //     log('error', message);
    //     res.status(400).send(message);
    //     return;
    // }
    const port = parseInt(req.body.port, 10);
    if (port < 1 || port > 65535) {
        const message = `Port in Invalid Range ${port}`;
        log('error', message);
        res.status(400).send(message);
        return;
    }
    if (next) {
        next();
    }
}
